import _ from 'lodash'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime, isBlank } from 'common/usual'
import {
  Card,
  CardContent,
  CardActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  TextField,
} from '@material-ui/core'
import AddBtn from 'components/AddBtn'
import EditBtn from 'components/EditBtn'
import { partnerDetailedListPromise } from 'api/Partner'
import { useLocation } from 'react-router-dom'

// `clientSecret` is not a column here because it is not in the response: the API strips it from
// every read and returns it exactly once, on create and on rotate.
export default function PartnerList (props) {
  const ref = useRef()
  const location = useLocation()
  const [data, setData] = useState({})
  const [params, setParams] = useState({})

  useEffect(() => {
    let cancelled = false
    const query = Object.fromEntries(new URLSearchParams(location.search).entries())

    setParams({ page: 1, ...query })
    partnerDetailedListPromise(query).then(resp => { if (!cancelled) setData(resp || {}) })

    return () => { cancelled = true }
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const query = Object.fromEntries(new URLSearchParams(location.search))
    const next = _.pickBy({ ...query, page: 1, ...payload }, _.identity)
    setParams(next)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(next)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              variant='outlined'
              size='small'
              placeholder='Name or client id'
              value={params.keyword || ''}
              className='background-color'
              onChange={event => handleParamsChange({ keyword: event.target.value }, 500)}
            />
          </Grid>
          <Grid item xs={8} className='flex-right'>
            <AddBtn color='primary' variant='contained' onClick={() => props.history.push('/partner-accounts/add')}>
              Add
            </AddBtn>
          </Grid>
        </Grid>

        <br />

        <Card>
          <CardContent className={'table-content'}>
            <PerfectScrollbar>
              <div className={'inner'}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Client ID</TableCell>
                      <TableCell>External ID</TableCell>
                      <TableCell>Token TTL (s)</TableCell>
                      <TableCell>Active</TableCell>
                      <TableCell>Updated At</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.rows && data.rows.map(partner => (
                      <TableRow key={partner.id} hover>
                        <TableCell>{partner.id}</TableCell>
                        <TableCell>{partner.name}</TableCell>
                        <TableCell>{partner.clientId}</TableCell>
                        <TableCell>{isBlank(partner.partnerExternalId) ? '-' : partner.partnerExternalId}</TableCell>
                        {/* 0 means the token never expires -- a real value, not a missing one */}
                        <TableCell>{isBlank(partner.jwtTokenTtlSeconds) ? '-' : partner.jwtTokenTtlSeconds}</TableCell>
                        <TableCell>{partner.active ? 'TRUE' : 'FALSE'}</TableCell>
                        <TableCell>{formatDateTime(partner.updatedAt)}</TableCell>
                        <TableCell>
                          <EditBtn history={props.history} path={`/partner-accounts/edit/${partner.id}`} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>
          </CardContent>

          <CardActions className='flex-right'>
            <TablePagination
              component='div'
              rowsPerPage={10}
              page={(params.page || 1) - 1}
              count={data.count || 0}
              rowsPerPageOptions={[10]}
              onPageChange={handlePageChange}
            />
          </CardActions>
        </Card>
      </div>
    </div>
  )
}
